var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew259({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.44,8.25c0-.57-.06-1.25-.06-1.76h0c-.13.48-.3,1-.51,1.55l-.72,2h-.4L3.07,8.07C2.88,7.5,2.72,7,2.6,6.49h0c0,.51,0,1.19-.08,1.8L2.4,10H1.9L2.19,6h.67l.69,2c.17.5.31,1,.41,1.37H4c.1-.41.25-.85.43-1.37l.72-2h.68L6.06,10H5.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.35,8A1.9,1.9,0,0,1,8.46,10.1,1.87,1.87,0,0,1,6.63,8,1.94,1.94,0,0,1,8.52,5.9,1.85,1.85,0,0,1,10.35,8ZM7.19,8c0,.87.47,1.65,1.3,1.65S9.8,8.91,9.8,8,9.37,6.33,8.5,6.33,7.19,7.13,7.19,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,10V6h.57L12.92,8a11.34,11.34,0,0,1,.73,1.33h0c-.05-.54-.06-1-.06-1.67V6h.5V10h-.53L12.27,8a14.39,14.39,0,0,1-.76-1.36h0c0,.51,0,1,0,1.68V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew259);
export default __webpack_public_path__ + "static/media/Symbolpack_New_259.7e00ff6809615051b72a9cac9c7cdbfa.svg";
export { ForwardRef as ReactComponent };